/*=========================================================================================
  File Name: modulePurchaseOrderGetters.js
  Description: Purchase ORder Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
